import { Logger } from '@quickplay/foundation';
import { BroadpeakSessionInitializationData } from './model/BroadpeakSessionInitializationData';
import { AdPlaybackPolicy, Player } from '@quickplay/player-interface';
import { BroadpeakAdsSessionData } from './BroadpeakAdsSession';
import { PALConfiguration } from '@quickplay/pal';
import { BroadpeakAdsPlayer } from './BroadpeakAdsPlayer';
import { BroadpeakPlayer } from './internal/BroadpeakPlayer';
import { createBroadpeakSessionInstance } from './internal/BroadpeakSession';

export async function createBroadpeakSession(
  sessionInitializationData: BroadpeakSessionInitializationData,
  initializationUrl: string,
  fallbackUrl: string,
  videoElement: HTMLVideoElement,
  allowStorage?: boolean,
  palConfiguration?: PALConfiguration,
  logger?: Logger,
): Promise<BroadpeakAdsSessionData> {
  return createBroadpeakSessionInstance(
    sessionInitializationData,
    initializationUrl,
    fallbackUrl,
    videoElement,
    allowStorage,
    palConfiguration,
    logger,
  );
}

export function createBroadpeakPlayer(
  player: Player,
  broadpeakSession: BroadpeakAdsSessionData,
  adPlaybackPolicy?: AdPlaybackPolicy,
  logger?: Logger,
): BroadpeakAdsPlayer {
  return new BroadpeakPlayer(player, broadpeakSession, adPlaybackPolicy, logger);
}
